export default "__VITE_ASSET__DH_R7El0__"